import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form, Text } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { useTranslation } from 'react-i18next'

const Concepts = ({ data, formData, mutations: { updateItem } }) => {
	const [t] = useTranslation()
	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={(values) => updateItem(values)}
				render={() => (
					<Row>
						<Col xs>
							<Text style={{ width: '90%' }} label={t('category_section.fields.concepts')} noForm readOnly value={data.name}/>
							<Text placeholder={t('category_section.placeholders.concepts')} field='concepts' multiField={5}/>
						</Col>
					</Row>
				)}/>
		</ContentBlock>
	)
}

export default Concepts
